import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  SupportIssueResolutionResponseDataSchema,
  SupportUpdateIssueResolutionSchema,
} from "schema"
import { z } from "zod"
import { getCustomerIssuesQueryKey } from "../lib/customerIssuesQuery"
import { getSupportIssuesQueryKey } from "../lib/supportIssuesQuery"

type Response = DataResponse<z.infer<typeof SupportIssueResolutionResponseDataSchema>>

export function useUpdateIssueResolutionMutation(issueId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (props: z.input<typeof SupportUpdateIssueResolutionSchema>) => {
      const { data } = await axios.put<Response>(
        `/support/entities/issues/${issueId}/resolution`,
        props,
      )
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getSupportIssuesQueryKey().slice(0, 2) })
      queryClient.invalidateQueries({ queryKey: [getCustomerIssuesQueryKey().at(0)] })
      queryClient.invalidateQueries({ queryKey: ["conversationSupportEntities"] })
    },
  })
}
